import './new-hcp.css';
import NewRelation from '../detail-page/input/relation';
import { Add, Cancel } from '@mui/icons-material';
import {
    Accordion, AccordionSummary,
    AccordionDetails, Typography, AccordionActions, IconButton, Link, Tooltip, DialogActions, Button, Stack,
    Card,
    CardContent,
    Chip,
    Alert
} from '@mui/material';
import IdentifiersView from '../detail-page/input/identifiers-view';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState, useEffect, useContext } from 'react';
import InputDetails from '../detail-page/input/detail-input-newHCP';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CONSTANT from '../../Constant/Constant'
import Popup from '../detail-page/error/popup';
import api from '../../service/api';
import filter from '../../service/filter';
import ProgressBar from '../progress/progressBar';
import ConfirmationDialogRaw from './popup-static';
import ErrorPage from '../error-page/error';
import Storage from '../../session/storage';
import moment from 'moment';
import jsondata from '../../config/NewHCPFormFields.json';
import { useLocation } from 'react-router-dom'
import popUpMessage from '../../config/popUpMsg.json';
import payloadCountry from "../../config/vendorPicklistApiPayload.json"
import { DirectionContext } from '../../context/DirectionProvider';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmationDialogRaw1 from '../globalSearch/popupGlobal';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import LillySources from '../../config/ProfileDetailsData.json'
import useLocalStorage from '../../hooks/useLocalStorage';
import {DropdownContext}  from '../../context/DropDownContext';

const AddNewHCP = (props) => {
    // const [value, setValue] = useState({});
    const location = useLocation();
    const { setDropdownValue } = useContext(DropdownContext)
    const [accordianFlag, changeAccordianFlag] = useState({ "mainInfo": true, "speciality": true, "Relation": true, "Address": true, Identifiers: true,"contactData": true })
    const [modal, setModal] = useState({ flag: false });
    const [error, setError] = useState(false);
    const [relationError, setRelationError] = useState(false);
    const [HCPRequest, setHCPRequest] = useState(CONSTANT.NEW_HCP_BODY);
    const [validRequest, setValidRequest] = useState();
    const [optionalRelation, setOptionalRelation] = useState('Not Set');
    const [clear, setClear] = useState(false);
    const [address, setAddress] = useState(false)
    const [showRelation, setShowRelation] = useState(false);
    const [showError] = useState(false);
    const [changeCompleted] = useState();
    const [loading, setLoading] = useState(true);
    const [lillySelectedCountry, setLillySelectedCountry] = useState([]);
    const [lillySelectedCountrysource, setLillySelectedCountrySource] = useState([]);
    const [showModal, setShowModal] = useState(true)
    const [errorMsg, setErrorMsg] = useState();
    const [data] = useState(jsondata);
    const [selectedCountry, setSelectedCountry] = useState('')
    const [filterdata, setfilterdata] = useState()
    const [iqviaEnnable, setIqviaEnnable ] = useState(false)  
    const [popMsg] = useState(popUpMessage.newHCP)   
    const [identifierSubmit, setIdentifierSubmit] = useState(false) 
    const [noIdentifierData, setNoIdentifierData] = useState(false)
    const direction = useContext(DirectionContext);    
    const [allCountry, setAllCountry] = useState('')
    const [closeSpecialtyPopup, setCloseSpecialtyPopup] = useState(false)
    const [newSource, setNewSource] = useState('')
    const [selectedSpecialty, setSelectedSpecialty] = useState({})
    const [allSpecialty, setAllspecialty] = useState([])
    const [showAllData, setShowAllData] = useState(false)
    const [userData] = useState(location.state.user)
    const [originalSource, setOriginalSource] = useState('')
    const [primarySpecialty, setPrimarySpecialty] = useState([])
    const [otherSpecialty, setOtherSpecialty] = useState([])
    var getPaylodCountry = payloadCountry.countries.find((res) => res.country_Name === location.state.country)
    var getdata;
    var requirefields = []
    const [langLocaleChange] = useLocalStorage('wglang_api')
    useEffect(() => {
    if (location.state.iqviaSource || location.state.homePage_Lilly) {
        handleFunction();
    }
    },[langLocaleChange])

    useEffect(() => {
        if(location?.state?.iqviaSource == undefined || location?.state?.iqviaSource == null || location.state.homePage_Lilly == undefined || location.state.homePage_Lilly == null){
            props.history.push('/')
        }  
        else{          
            setLoading(true);     
            setIqviaEnnable(location.state.iqviaSource)           
            async function fetchDetails() {
                await api.getSelectedDCRCountry().then((countryList) => {                         
                var countryListData = countryList.data.filter((arr)=> { return !arr.includes('#')}) 
                setAllCountry(countryList.data)
                setLillySelectedCountry(countryListData.map((el)=> {return el.split('#')[0]}))    
                setLillySelectedCountrySource(countryList.data)  
                setTimeout(() => {
                    setLoading(false);
                }, 4000);              
                               
                   
                }).catch((error) => {
                    let errorDetail = error;
                    let msg = errorDetail.response ? errorDetail.response.data.errorCode : 'Internal Server Error!';
                    setErrorMsg(msg ? msg : 'Internal Server Error!');
                    setLoading(false);
                })
            }

            fetchDetails();       
            
            if( (location.state.iqviaSource || location.state.homePage_Lilly) )   {
               handleFunction();
    
            }                 

        }
       
        
    }, [location.state.country, location.state.source, location.state.newSpecialty])

    // Fetching country data for displaying input field of Iqvia country
    const countryDataFetch = (newSource)=>{         
        getdata = data.countries.find((el) => {
            if(el.country_Name == location.state.country){
                return el.country_Name === location.state.country
            }
            else{
                return el.country_Name == "default"
            }})

        if (location.state.source == 'VNDR-CGDM' || newSource == 'VNDR-CGDM') {
          setfilterdata(getdata.input.iqvia)
        } else if (location.state.source == 'VNDR-VN' || newSource == 'VNDR-VN') {
          setfilterdata(getdata.input.veeva)
        } else if (location.state.source == 'VNDR-VOD' || newSource == 'VNDR-VOD') {
            setfilterdata(getdata.input.openData)
        }else{
          setfilterdata(getdata.input.eph)
        }
        setSelectedCountry(location.state.country ? location.state.country : selectedCountry)

    }
    // handle function for handling body of iqvia input field
    const handleFunction = ()=>{        
        let receivedResponse ;
        setLoading(true)
        api.getPickList((getPaylodCountry ? getPaylodCountry?.key?.payloadKey : location.state.country) , (location.state.source ? location.state.source : null), location.state.allSelectedSpecialty,'HCP', undefined, langLocaleChange ).then((res) => {   
            let source = ''
            if(getPaylodCountry?.key?.payloadKey== 'United States' ||  location.state.country == 'United States'){
                Storage.setLovBoundedList(filter.mapVnPickList(res.data[0]))
            }else{
                Storage.setLovBoundedList(filter.mapPickList(res.data[0]))
                setDropdownValue(filter.mapPickList(res.data[0]))
            }
            if(!location.state.source){
              if (location.state?.country == "United States") {
                receivedResponse = source = "VNDR-VN"
              }
              else {
                receivedResponse = source = res.data[0]['source'][0]
                setNewSource(source)                
                countryDataFetch(source);
                setOriginalSource(source)
              }
                
            }
            else{
              receivedResponse = source = res.data[0]['source'][0]
              setNewSource(source)
              setOriginalSource(source)
              countryDataFetch(source); 
            }      
            setShowModal(false)
            setLoading(false)  
            setShowAllData(true)          

        }).catch((error) => {
            let errorDetail = error;
            let msg = errorDetail.response ? errorDetail.response.data.errorCode : 'Internal Server Error!';
            setErrorMsg(msg ? msg : 'Internal Server Error!');     
            setLoading(false)      
        })

        if(location.state.homePage_Lilly && receivedResponse == 'VNDR-CGDM' )
            {
                setHCPRequest({
                    entity: {
                        type: "configuration/entityTypes/HCP",
                        ActiveFlag: [{ value: 'Y' }],
                        EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
                        EffectiveEndDate: [{ value: "9999-12-31" }], NewSpecialities: location.state.newSpecialty , 
                        NewIdentifiers: [] , Address: undefined, Source: [{ value: location.state.source ? location.state.source : receivedResponse }]
                    }, relations: [], RequestTo: location.state.vendor, vendor: location.state.vendor
                })
            }
        else if (location.state.homePage_Lilly && (receivedResponse == 'VNDR-VN' || location.state?.source == 'VNDR-VN')) {
          setHCPRequest({
            entity: {
              type: "configuration/entityTypes/HCP",
              ActiveFlag: [{ value: 'Y' }],
              EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
              EffectiveEndDate: [{ value: "9999-12-31" }], NewSpecialities: location.state.newSpecialty,
              NewIdentifiers: [], Address: undefined, Source: [{ value: location.state.source ? location.state.source : receivedResponse }]
            }, relations: [], RequestTo: 'VNETWORK', vendor: 'VNETWORK'
          })
        }
        else if(location.state.homePage_Lilly && receivedResponse != 'VNDR-CGDM' )
            {
                setHCPRequest({entity: {
                    type: "configuration/entityTypes/HCP",
                    ActiveFlag: [{ value: 'Y' }],
                    EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
                    EffectiveEndDate: [{ value: "9999-12-31" }], NewSpecialities: location.state.newSpecialty ,NewIdentifiers: [] , 
                    Address: undefined, Source: [{ value: location.state.source ? location.state.source : receivedResponse }]}, relations: []})
            }
        else{
            setHCPRequest({
                entity: {
                    type: "configuration/entityTypes/HCP",
                    ActiveFlag: [{ value: 'Y' }],
                    EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
                    EffectiveEndDate: [{ value: "9999-12-31" }], NewSpecialities: undefined, 
                    NewIdentifiers: [] , Address: undefined, Source: [{ value: location.state.source }]
                }, relations: [], RequestTo: location.state.vendor, vendor: location.state.vendor
            })

        }   
        var value = location.state.country
        updateValue({value}, false, 'CountryCode')       
        window.scroll(0,0)
    }
    
    useEffect(()=>{
        if(!iqviaEnnable){
            if(newSource == 'VNDR-CGDM' )
                {        
                    setHCPRequest({
                        entity: {
                            type: "configuration/entityTypes/HCP",
                            ActiveFlag: [{ value: 'Y' }],
                            EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
                            EffectiveEndDate: [{ value: "9999-12-31" }], NewSpecialities: location.state.newSpecialty ? location.state.newSpecialty : selectedSpecialty , 
                            NewIdentifiers: [] , Address: undefined, Source: [{ value: location.state.source ? location.state.source : newSource }]
                        }, relations: [], RequestTo: location.state.vendor ? location.state.vendor : 'IQVIA', vendor: location.state.vendor ? location.state.vendor : 'IQVIA'
                    })
                }
            else if (newSource == 'VNDR-VN' || location.state.source == 'VNDR-VN') {
              setHCPRequest({
                entity: {
                  type: "configuration/entityTypes/HCP",
                  ActiveFlag: [{ value: 'Y' }],
                  EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
                  EffectiveEndDate: [{ value: "9999-12-31" }], NewSpecialities: location.state.newSpecialty ? location.state.newSpecialty : selectedSpecialty,
                  NewIdentifiers: [], Address: undefined, Source: [{ value: location.state.source ? location.state.source : newSource }]
                }, relations: [], RequestTo: 'VNETWORK', vendor: 'VNETWORK'
              })
            }
            else
                {   
                    setHCPRequest({entity: {
                        type: "configuration/entityTypes/HCP",
                        ActiveFlag: [{ value: 'Y' }],
                        EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
                        EffectiveEndDate: [{ value: "9999-12-31" }], NewSpecialities: location.state.newSpecialty ? location.state.newSpecialty : selectedSpecialty ,NewIdentifiers: [] , 
                        Address: undefined, Source: [{ value: location.state.source ? location.state.source : newSource }]}, relations: []})
                }

        }
        
        var value = location.state.country ? location.state.country : selectedCountry
        updateValue({value}, false, 'CountryCode')  
    },[newSource,location.state.country, location.state.newSpecialty, selectedCountry, selectedSpecialty])
    
    // Accordian close
    const closeAccordian = (id) => {
        changeAccordianFlag({
            ...accordianFlag,
            [id]: !accordianFlag[id]
        })
    }

    /**
     * Back to home
     */
    const goBack = () => {
        props.history.push('/')
    }
    //finding out all the countries value for vendor
    const editCountry = () => {
        if(location.state.homePage_Lilly){
            setCloseSpecialtyPopup(true)
        }

        if(!location.state.homePage_Lilly && !iqviaEnnable){
            setShowModal(true)
        }
    }

    // const mapResponse = (value) => {
    //     if (value === undefined) {
    //         return [];
    //     } else {
    //         return (value.length > 0 ? value : [])
    //     }
    // }
    /**
     * Update all values
     * @param {*} newValue 
     * @param {*} flag 
     * @param {*} attribute 
     */
    const updateValue = (newValue, flag, attribute) => {        
       if(!!newValue &&  attribute != 'Relation' && attribute != "Identifiers" && attribute != "OtherSpecialty" )
       {
        Object.keys(newValue).forEach(k => {
            if(typeof newValue[k] === 'string')
                newValue[k] = newValue[k].trim();
        });
       }      

        
        if (attribute === 'CountryCode') {
            if (newValue.value !== null && !CONSTANT.HCP_RELATION.includes(newValue.value)) {
                setOptionalRelation('Required');
                setAddress(false);
                setShowRelation(true);
            } else if (newValue.value !== null && CONSTANT.HCP_RELATION.includes(newValue.value)) {
                setOptionalRelation('Optional');
                setRelationError(false);
                setAddress(true);
                setShowRelation(false);
            } else {
                setOptionalRelation('Not Set');
                setHCPRequest((oldvalue) => ({
                    ...oldvalue,
                    entity: {
                        ...oldvalue.entity,
                        Address: undefined

                    }

                }))
                setAddress(false);
                setShowRelation(false);
                delete HCPRequest.relations;
                delete HCPRequest.entity.Address;
            }

        }


        
        if (attribute !== 'Relation') {
            if (CONSTANT.SPECIALITY_TYPE.includes(attribute)) {
                setHCPRequest((oldvalue) => ({
                    ...oldvalue,
                    entity: {
                        ...oldvalue.entity,
                        NewSpecialities: {
                            ...oldvalue.entity.NewSpecialities,
                            [attribute]: [newValue]
                        }
                    }
                }))
            } else if (attribute === "Identifiers") {
                if (HCPRequest && HCPRequest["entity"]) {
                    setHCPRequest((oldValue)=> ({
                        ...oldValue,
                        entity:{
                            ...oldValue.entity,
                            NewIdentifiers: newValue
                        }
                    }));
                }
            }
            else {
                if (attribute.split('.')[0] === 'Address') {
                    if (HCPRequest.entity.Address !== undefined) {
                        setHCPRequest((oldvalue) => ({
                            ...oldvalue,
                            entity: {
                                ...oldvalue.entity,
                                Address: [{
                                    ...oldvalue.entity.Address[0],
                                    [attribute.split('.')[1]]: [newValue],
                                    Rank: [{ value: '1' }],
                                    EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
                                    EffectiveEndDate: [{ value: "9999-12-31" }]
                                }]
                            }
                        }))
                    }
                    else {
                        setHCPRequest((oldvalue) => ({
                            ...oldvalue,
                            entity: {
                                ...oldvalue.entity,
                                Address: [{
                                    [attribute.split('.')[1]]: [newValue]
                                }]
                            }
                        }))
                    }
                } else {
                    setHCPRequest((oldvalue) => ({
                        ...oldvalue,
                        entity: {
                            ...oldvalue.entity,
                            [attribute]: [newValue]
                        }
                    }))
                }
            }
        } else {
            if (newValue === undefined) {
                
                setHCPRequest((oldValue) => {
                    return {
                        ...oldValue,
                        relations: []
                    }
                });
            } else {
                if (newValue.Country === undefined) {
                   
                    setHCPRequest((oldValue) => ({
                      ...oldValue,
                      relations: [
                        {
                          uri: newValue?.HCO?._id,
                          type: newValue?.HCO?._source?.type,
                          label: newValue?.HCO?._source?.label,
                          EffectiveStartDate: [
                            {
                              value: moment
                                .utc(new Date())
                                .format("YYYY-MM-DD"),
                            },
                          ],
                          IsNew: true,
                          EffectiveEndDate: [{ value: "9999-12-31" }],
                          Rank: newValue.Rank
                          ? newValue.Rank
                          : [{ value: "99" }],
                          Source: newValue?.HCO?._source?.Source,
                          DepartmentIndicator:
                            newValue?.HCO?._source?.DepartmentIndicator,
                          IsPrimary:
                            newValue.Rank &&
                            newValue.Rank[0].value == 1 
                              ? true
                              : false,
                          relationTypeCode: newValue?.Affiliations ? newValue?.Affiliations[0]?.value : undefined,
                        },
                      ],
                    }));
                    

                } else {
                    const { AddressLine1, City, Zip, StateProvince, Country, ClassificationCode,
                            BrickId, BrickEffectiveEndDate } = newValue;
                    const brickEntry = BrickId ? [{
                        [CONSTANT.BRICK_FIELDS.BRICK_TYPE]: [{ value: 'BRK' }],
                        [CONSTANT.BRICK_FIELDS.BRICK_ID]: BrickId,
                        [CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_START_DATE]: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
                        [CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_END_DATE]: BrickEffectiveEndDate || [{ value: '9999-12-31' }],
                        [CONSTANT.BRICK_FIELDS.BRICK_SOURCE]: [{ value: 'LLY-MNGD' }],
                    }] : undefined;
                    setHCPRequest((oldValue) => ({
                      ...oldValue,
                      relations: [
                        {
                          Country,
                          ClassificationCode,
                          Name: newValue.HCO,
                          ActiveFlag: [{ value: "Y" }],
                          Address: [
                            {
                              AddressLine1,
                              City,
                              Zip,
                              StateProvince,
                              Country,
                              ...(brickEntry && { BRICK: brickEntry }),
                              EffectiveStartDate: [
                                {
                                  value: moment
                                    .utc(new Date())
                                    .format("YYYY-MM-DD"),
                                },
                              ],
                              EffectiveEndDate: [{ value: "9999-12-31" }],
                              Rank: [{ value: "1" }],
                            },
                          ],
                          EffectiveStartDate: [
                            {
                              value: moment
                                .utc(new Date())
                                .format("YYYY-MM-DD"),
                            },
                          ],
                          EffectiveEndDate: [{ value: "9999-12-31" }],
                          Rank: newValue.Rank
                            ? newValue.Rank
                            : [{ value: "99" }],
                          Source: [{ value: newSource }],
                          IsNew: true,
                          IsPrimary:
                            newValue.Rank &&
                            newValue.Rank[0].value == 1
                              ? true
                              : false,
                          relationTypeCode: newValue?.Affiliations ? newValue?.Affiliations[0]?.value : undefined,
                        },
                      ],
                    }));
                }
            }
        }

        if (attribute.split('.')[0] === 'Address') {
            let allAddressFlag = false;
            const isLillyManaged = CONSTANT.BRICK_LILLY_MANAGED_SOURCES.includes(HCPRequest?.entity?.Source?.[0]?.value);
            const fieldsToCheck = CONSTANT.ADDRESS_ATTRIBUTE.filter(f => f !== 'BRICK' || isLillyManaged);
            fieldsToCheck.forEach((value) => {
                let addresValue = HCPRequest.entity.Address ? HCPRequest.entity.Address[0] : undefined;
                if (attribute.split('.')[1] !== value) {
                    allAddressFlag = allAddressFlag ||
                        !(addresValue && addresValue[value] !== undefined && addresValue[value][0].value.length !== 0);
                } else {
                    allAddressFlag = allAddressFlag || !(newValue.value.length !== 0);
                }
            })
            setValidRequest((old) => ({
                ...old,
                Address: allAddressFlag
            }))
        } else {
            setValidRequest((old) => ({
                ...old,
                [attribute]: flag
            }))
        }

    }

    const checkIdentifierSubmitted = (addflag, identifierType,identifierId,identifierSaved)=>{
                
              
        if(addflag && (((identifierType?.length == 0) && (identifierId?.length == 0 )) || ((identifierType == undefined) && (identifierId == undefined ) )) && identifierSaved == false)
        {
            
         setNoIdentifierData(true)
         setIdentifierSubmit(false)
        }
        else if(addflag && identifierType?.length > 0 && identifierId?.length > 0  && identifierSaved == false)
        {

        setIdentifierSubmit(true)
        setNoIdentifierData(false)

        }
      
        else{

        setIdentifierSubmit(false)
        setNoIdentifierData(false)
        }
      

    }

    /**
     * Submit NEw HCP Request
     */
    const submitRequest = () => {
        let isValid = true;

        if (HCPRequest === undefined || validRequest === undefined ) {
            setError(true);
            setModal(true);

        }else if(noIdentifierData){
            setModal({
                flag: true,
                success: false,
                message: 'Please enter data into the Identifier fields before Submitting Request !',
                title: 'Error'
            });
        }
        
        else if(identifierSubmit)
        {
            setModal({
                flag: true,
                success: false,
                message: 'Please save the identifiers before submitting the request',
                title: 'Error'
            });
        }   
         else {
            let errorFlag = false;
            requirefields.forEach((id) => {
                let value = validRequest[id];
                if ((id === 'Relation') && !showRelation) {
                    errorFlag = errorFlag || false;
                    setRelationError(false);
                }else if ((id === 'Address') && !address) {
                    errorFlag = errorFlag || false;
                    setRelationError(false);
                }
                else if (validRequest['Relation'] === undefined || validRequest['Relation'] === true ) {
                    
                    errorFlag = errorFlag || true;
                    setRelationError(true);
                    const country = getPaylodCountry.country_Name;
                     // #keeping the relations optional for united states in hcp form
                     if (country == "United States") {
                         // isValid = false;
                       }
                     else{
                         isValid = false; 
                     }               
                    
                }
                else{
                    if (value === undefined || value === true) {
                        errorFlag = errorFlag || true;
                        setRelationError(true);
                        isValid = false;
                    }
                }
            });
            setError(errorFlag);
            setRelationError(true && showRelation && errorFlag);
            if (isValid) {

                setModal({
                    flag: true,
                    message: 'Comments *',
                    success: true,
                    title: 'Submit Request'
                });
            } else {
                setModal({
                    flag: true,
                    success: false,
                    message: popMsg[0].blankField.description,
                    title: popMsg[0].blankField.heading
                });
            }
        }
    }


    /**
     * Clear all Inputs
     */
    const clearAll = () => {
        setError(false);
        setRelationError(false)
        let CountryCode = JSON.parse(JSON.stringify(HCPRequest.entity.CountryCode[0]));
        let RequestTo = HCPRequest?.RequestTo;
        let vendor = HCPRequest?.vendor;
        let Source = HCPRequest?.entity?.Source;
        setHCPRequest(CONSTANT.NEW_HCP_BODY);
        RequestTo && vendor && setHCPRequest((oldvalue) => ({
            ...oldvalue,
            entity: {
                ...oldvalue.entity,
                Source: Source ? Source : [{ value: newSource }],
            },
            RequestTo: RequestTo,
            vendor: vendor}))
        setClear(true);
        updateValue(CountryCode, false, 'CountryCode')
        updateValue([],true,"Identifiers");//clear populated identifiers
        let intervalId = setTimeout(() => {
            setClear(false);
            clearTimeout(intervalId)
        }, 1000)
    }

    /**
     * Add optional fields based on country
     * @param {*} attribute 
     */
    const addOptional = (attribute) => {
        if (attribute === 'Relation') {
            setValidRequest((oldvalue) => ({ ...oldvalue, Relation: true }));
        } else {
            setValidRequest((oldvalue) => ({ ...oldvalue, Address: true }));
        }
    }

    /**
     * handle delete
     * @param {*} attribute 
     */
    const setCancel = (attribute) => {
        if (attribute === 'Relation') {
            setValidRequest((oldvalue) => ({ ...oldvalue, Relation: false }))
            // delete HCPRequest.relations;
            HCPRequest.relations = [];
        } else {
            setValidRequest((oldvalue) => ({ ...oldvalue, Address: false }))
            delete HCPRequest.entity.Address;
        }
    }

    /**
     * show form based on country popup
     * @param {*} value 
     */
    const handleOk = (value, newSpecialty, allSelectedSpecialty, primarySpecialty, otherSpecialty) => {
        if (allSelectedSpecialty.every((res)=> allSpecialty.includes(res)) && selectedCountry == value){
            setShowModal(false)
        }
        else{
        setSelectedCountry(value)
        setPrimarySpecialty(primarySpecialty)
        setOtherSpecialty(otherSpecialty)
        let receivedResponse ;
        let getPaylodCountry = payloadCountry.countries.find((res) => res.country_Name === value)
        var getdata = data.countries.find((el) => {
            if(el.country_Name == value){
                return el.country_Name === value
            }
            else{
                return el.country_Name == "default"
            }
               
        }) 
        updateValue( {value}, false, 'CountryCode')        
        setSelectedSpecialty(newSpecialty)
        setAllspecialty(allSelectedSpecialty)
        setLoading(true);

        api.getPickList((getPaylodCountry ? getPaylodCountry?.key?.payloadKey : value), null, allSelectedSpecialty, 'HCP').then((res) => {
            if(getPaylodCountry?.key?.payloadKey== 'United States' ||  location.state.country == 'United States'){
                Storage.setLovBoundedList(filter.mapVnPickList(res.data[0]))
            }else{
                Storage.setLovBoundedList(filter.mapPickList(res.data[0]))
            }
            let source = '';
            const country = getPaylodCountry ? getPaylodCountry?.key?.payloadKey : value
            if (country == "United States") {
              receivedResponse = source = "VNDR-VN"
            }
            else {
              receivedResponse = source = res.data[0]['source'][0]
            }
            setNewSource(receivedResponse)
            // setfilterdata(receivedResponse == 'VNDR-CGDM' ? getdata.input.iqvia : getdata.input.eph)
            if (receivedResponse == 'VNDR-CGDM') {
              setfilterdata(getdata.input.iqvia)
            } else if (receivedResponse == 'VNDR-VN') {
              setfilterdata(getdata.input.veeva)
            } else if (receivedResponse == 'VNDR-VOD') {
                setfilterdata(getdata.input.openData)
            } else {
              setfilterdata(getdata.input.eph)
            }

            setOriginalSource(receivedResponse) 
            setLoading(false);
            setShowModal(false)  
            setShowAllData(true)         

        }).catch((error) => {
            let errorDetail = error;
            let msg = errorDetail.response ? errorDetail.response.data.errorCode : 'Internal Server Error!';
            setErrorMsg(msg ? msg : 'Internal Server Error!');
            setLoading(false);
        })

        if(receivedResponse == 'VNDR-CGDM' )
            {
                setHCPRequest({
                    entity: {
                        type: "configuration/entityTypes/HCP",
                        ActiveFlag: [{ value: 'Y' }],
                        EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
                        EffectiveEndDate: [{ value: "9999-12-31" }], NewSpecialities: newSpecialty,
                        NewIdentifiers: [] , Address: undefined, Source: [{ value: receivedResponse }]
                    }, relations: [], RequestTo: 'IQVIA', vendor: 'IQVIA'
                })
            }
        else
            {
                setHCPRequest({entity: {
                    type: "configuration/entityTypes/HCP",
                    ActiveFlag: [{ value: 'Y' }],
                    EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
                    EffectiveEndDate: [{ value: "9999-12-31" }], NewSpecialities: newSpecialty ,NewIdentifiers: [] , 
                    Address: undefined, Source: [{ value: receivedResponse}]}, relations: []})
            }       
  
        }    
    }
    /**
     * change source and form fields
     * @param {*} 
     */
    const changeSourceAndFields = () =>{        
        setLoading(true)
        api.getPickList(selectedCountry, originalSource == 'VNDR-VOD' && newSource == 'MNGD-AFF' ? originalSource : LillySources.SOURCE_OVERRIDED[0][newSource]).then((res) => {   
            setNewSource(originalSource == 'VNDR-VOD' && newSource == 'MNGD-AFF' ? originalSource : LillySources.SOURCE_OVERRIDED[0][newSource]);
            countryDataFetch(originalSource == 'VNDR-VOD' && newSource == 'MNGD-AFF' ? originalSource : LillySources.SOURCE_OVERRIDED[0][newSource]);
            if(getPaylodCountry?.key?.payloadKey== 'United States' ||  location.state.country == 'United States'){
                Storage.setLovBoundedList(filter.mapVnPickList(res.data[0]))
            }else{
                Storage.setLovBoundedList(filter.mapPickList(res.data[0]))
            }
            setLoading(false)
            setShowAllData(true)
        }).catch((error) => {
            let errorDetail = error;
            let msg = errorDetail.response ? errorDetail.response.data.errorCode : 'Internal Server Error!';
            setErrorMsg(msg ? msg : 'Internal Server Error!');     
            setLoading(false)      
        })
    }
    //function to close specialty popup
    const closePopup= () =>{ 
        if(showModal){
            setShowModal(false)
        }
        else{
            setCloseSpecialtyPopup(false)
        }        
    }

    // change the source for HCO search for US
    let hcoSearchSource = HCPRequest.entity?.Source[0]?.value
    let identifierviewparams = {}
    if (HCPRequest.entity?.CountryCode && HCPRequest.entity?.CountryCode[0]?.value == "United States") {
      hcoSearchSource = "IQVIA_US"
      const lovBounds = Storage.getLovBoundedList()
      if (lovBounds && lovBounds.AltIDType_VN) {
        identifierviewparams = {
          "identifierOptions": lovBounds.AltIDType_VN
        }
      }
    }

    return (
        <div className='body-height'>
            { loading &&
                
                <div className="extra-margin-top d-flex justify-content-center body-height">
                    <ProgressBar 
                     />
                </div>
            }            
            {closeSpecialtyPopup && !loading &&
                <ConfirmationDialogRaw1
                    open={closeSpecialtyPopup}
                    option={allCountry}
                    entityType={'HCP'}
                    selectedCountry = {location.state.country}
                    SelectedSpecialtyValue = {location.state.newSpecialty}
                    allSelectedSpecialty = {location.state.allSelectedSpecialty}
                    primarySpecialty = {location.state.primarySpecialty}
                    otherSpecialty = {location.state.otherSpecialty}
                    onOk={closePopup}
                    onCancel={closePopup}
                    user= {props.user}
                    entity="HCP"
                
                />
            }
            {
                !loading && errorMsg === undefined && !iqviaEnnable && !location?.state?.homePage_Lilly  && allCountry.length > 0 &&                
                <div className='w-100'>
                    <ConfirmationDialogRaw
                        id="static-popup"
                        open={showModal}
                        entityType={'HCP'}
                        onOk={(country, newSpecialty, allSelectedSpecialty, primarySpecialty, otherSpecialty)=> handleOk(country, newSpecialty, allSelectedSpecialty, primarySpecialty, otherSpecialty)}
                        option={allCountry}                      
                        selectedCountry = {selectedCountry}
                        SelectedSpecialtyValue = {selectedSpecialty}
                        allSelectedSpecialty = {allSpecialty}
                        primarySpecialty = {primarySpecialty}
                        otherSpecialty = {otherSpecialty}
                        onCancel={closePopup}
                        showAllData = {showAllData}
                        entity="HCP"

                    />
                </div>
            } 
            {
                !loading && errorMsg === undefined && showAllData &&
                <div className="extra-margin-top-less container w-80 body-height min-width">
                    <Stack
                        direction='row'
                        justifyContent="flex-start"
                        alignItems='center'
                        gap={1}
                    >
                        <Tooltip disableFocusListener title="Back" id='tltipStrictSearchChckbx'>
                            <IconButton aria-label="delete"
                                onClick={goBack}
                                className="text-danger float-end"
                                color="secondary"
                            >
                                <ArrowBackIcon 
                                    sx={{ transform:direction==='rtl'?'rotate(180deg)':''}} 
                                />
                            </IconButton>
                        </Tooltip>
                        <Typography variant="h1" margin={0} style={{ fontSize: 21 }} id="newhcp-text">
                            HCP Details
                        </Typography>
                    </Stack>
                    {!iqviaEnnable &&
                    <>
                    <Card className='p-0 mb-3 mt-2'>
                        <IconButton aria-label="delete"
                            onClick={editCountry}
                            sx={{float:'right', marginLeft:'30px'}}                                
                        >
                            <Tooltip disableFocusListener title="Edit details   " id="tooltip" >
                                <EditIcon sx={{ transform:direction==='rtl'?'rotate(180deg)':''}} />
                        </Tooltip>
                        </IconButton>                           

                        <CardContent className='p-2'>
                        <Stack
                        direction='row'
                        justifyContent= {'space-between'}
                        alignItems='center'
                        flexWrap={'wrap'}  
                        className='p-0 m-0'   
                    >
                        <Typography variant='p' margin={0} id='newhcp-text'>
                            <span className="text-muted">Country: </span> 
                            <span className='_wg-exclude'>{location.state.country ? location.state.country : selectedCountry  } </span>                        
                        </Typography>
                        <Typography variant='p' margin={0} id='newhcp-text'>
                            <span className="text-muted">Source: </span>
                            <span className='_wg-exclude'>{location.state.source ? location.state.source : newSource}</span>
                        </Typography>
                        <Typography variant='p' margin={0} id='newhcp-text'>
                            <span className="text-muted">Primary Specialty: </span>
                            <span className='_wg-exclude'>{location.state.newSpecialty ? location.state.newSpecialty.PrimarySpecialty[0].value.split('#')[0]: ( selectedSpecialty.PrimarySpecialty ? selectedSpecialty.PrimarySpecialty[0].value.split('#')[0] : '')}</span>
                        </Typography>
                        {location.state.newSpecialty?.OtherSpecialty && location.state.newSpecialty?.OtherSpecialty[0]?.value.length > 0 &&
                        <Typography variant='p' margin={0} id='newhcp-text'>
                            <span className="text-muted">Other Specialities:</span>                            
                            {
                                location.state.newSpecialty?.OtherSpecialty[0]?.value?.map((res, key)=>{
                                    return(
                                        <Chip className='_wg-exclude' key={key} label={res.split('#')[0]} size="small" sx={{marginLeft:'5px'}} />
                                    )
                                })
                            }                            
                        </Typography>
                        }
                        {selectedSpecialty?.OtherSpecialty && selectedSpecialty?.OtherSpecialty[0]?.value.length > 0 &&
                        <Typography variant='p' margin={0} id='newhcp-text'>
                            <span className="text-muted">Other Specialities:</span>                            
                            {
                                selectedSpecialty?.OtherSpecialty[0]?.value?.map((res, key)=>{
                                    return(
                                        <Chip className='_wg-exclude' key={key} label={res.split('#')[0]} size="small" sx={{marginLeft:'5px'}} />
                                    )
                                })
                            }                            
                        </Typography>
                        }
                        </Stack>                                          
                        </CardContent>                        
                    </Card>
                    {userData?.dcrSourceOverride && (LillySources.OVERRIDED_DCR_SOURCE.includes(originalSource)) &&  originalSource !== 'MNGD-AFF' && originalSource != 'IQVIA_US' && data.allow_override_dcr &&
                    <Alert 
                    icon={<AltRouteIcon fontSize='inherit'/>}
                    action={
                        <Button color="error"  size='small' variant="contained" className='routeButtonContain' onClick={()=> changeSourceAndFields()}>
                        Yes
                        </Button>
                    }
                    className='mb-3' 
                    severity='warning'                    
                    >
                        {!LillySources.LILLY_MANAGED_SOURCES.includes(newSource) && 
                        <>{popMsg[0].sourceOverride["description"].replace(/{{source}}/g, originalSource).replace(/{{source1}}/g, LillySources.SOURCE_OVERRIDED[0][newSource])}</>}
                        { originalSource != "MNGD-AFF" && newSource == "MNGD-AFF" && (
                        <>{popMsg[0].sourceOverride["description-1"].replace(/{{source}}/g, newSource).replace(/{{source1}}/g, originalSource ) }</>
                        )}                    
                    </Alert>
                    }
                    </>
                    }                  
                    <div>
                    {
                        filterdata?.map((el, index) => {
                            return (
                                (!iqviaEnnable
                                ? el.id != 'speciality' && el.id != 'Address'
                                : el.id != 'Address') && (
                                <Accordion
                                    key={index}
                                    className=' shadow-md'
                                    expanded={accordianFlag[el.id]}
                                >
                                    <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls='panel1a-content'
                                    id={el.id}
                                    onClick={() => closeAccordian(el.id)}
                                    >
                                    <Typography id='newhcp-text' fontWeight="bold">{el.heading}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                    <div className=' row container w-100 p-3 pt-0'>
                                        {el.attributes
                                        .sort((a, b) => {
                                            return a.order - b.order
                                        })
                                        .map((value, key) => {
                                            if (value.required) {
                                            requirefields.push(value.id)
                                            }

                                            return (
                                            value.active === true && (
                                                <div key={key} className='col-sm-12 col-md-6 '>
                                                <span id='newhcp-text'>{value.name}</span>
                                                {value.required && (
                                                    <span className='required-asterisk-exclusion'> *</span>
                                                )}
                                                <InputDetails
                                                    vendor={location.state.source ? location.state.source : newSource}
                                                    clear={clear}
                                                    date={false}
                                                    newHCP={true}
                                                    newValue={filterdata}
                                                    require={value.required}
                                                    error={error}
                                                    type={value.type}
                                                    value={''}
                                                    label={value.name}
                                                    updatedValue={(newValue, flag) => {
                                                    updateValue(newValue, flag, value.id)
                                                    }}                                                  
                                                    countryName={HCPRequest.entity.CountryCode[0].value}
                                                    sourceName={HCPRequest.entity.Source[0].value}
                                                    entity = {'HCP'}
                                                />
                                                </div>
                                            )
                                            )
                                        })}
                                    </div>
                                    </AccordionDetails>
                                </Accordion>
                                )
                            )
                        })
                    }
                    <IdentifiersView 
                        {...identifierviewparams}
                        addFlag={"HCP"} 
                        mode={'Edit'} 
                        entity = {'HCP'}
                        change={changeCompleted} 
                        error={showError} 
                        label={"Identifier"} 
                        updatedValue={(newValue, flag) => { updateValue(newValue, flag, "Identifiers") }} 
                        heading={'Type&ID'} 
                        value={HCPRequest.entity.NewIdentifiers} 
                        checkIdentifierSubmitted = {(addflag, identifierType,identifierId,identifierSaved) => {checkIdentifierSubmitted(addflag, identifierType,identifierId,identifierSaved)} }
                        submit={identifierSubmit}
                        shadow={true}
                        vendor={location.state.vendor}
                    /> 
                </div>
                <>
                {
                    showRelation && !iqviaEnnable && (
                        <Accordion className=' shadow-md' expanded={accordianFlag['Relation']}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls='panel1a-content'
                            id='FirstName'
                            onClick={() => closeAccordian('Relation')}
                        >
                            <Typography id='newhcp-text' fontWeight="bold">{'Relation'}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className='w-100'>
                            <NewRelation
                                clear={clear}
                                country={HCPRequest.entity.CountryCode[0].value}
                                source={hcoSearchSource}
                                newHCP={true}
                                newData={filterdata}
                                error={relationError}
                                AddNewRelation={(newValue, flag) => {
                                updateValue(newValue, flag, 'Relation')
                                }}
                                showRelationType = {LillySources.OPEN_DATA_SOURCES.includes(HCPRequest.entity.Source[0].value) ? true : false}
                                iqviaEnnable = {iqviaEnnable}
                                searchHCOPayload={data.search_hco_payload.country_config[HCPRequest.entity.CountryCode[0].value] ? data.search_hco_payload.country_config[HCPRequest.entity.CountryCode[0].value] : data.search_hco_payload.country_config['Default']}
                                hcoQuery= {data.search_hco_payload}
                            />
                            </div>

                            {optionalRelation === 'Optional' && (
                            // <Link to='#' className='pointer' onClick={() => { setShowRelation(false); setCancel('Relation') }}><Cancel className="text-danger " /></Link>
                            <Stack direction={'row'} justifyContent={'flex-end'}>
                                <Button //Same button styling is used in identifiers-view. Could make this into its own component for canceling certian fields.
                                sx={{
                                    color: 'gray',
                                    '&:hover': { background: 'rgba(134,136,138,0.05)' }
                                }}
                                size='small'
                                onClick={() => {
                                    setShowRelation(false)
                                    setCancel('Relation')
                                }}
                                >
                                Cancel
                                </Button>
                            </Stack>
                            )}
                        </AccordionDetails>
                        </Accordion>
                    )
                }

                {
                    showRelation && iqviaEnnable && (
                    <Accordion className=' shadow-md' expanded={accordianFlag['Relation']}>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls='panel1a-content'
                        id='FirstName'
                        onClick={() => closeAccordian('Relation')}
                        >
                        <Typography id='newhcp-text' fontWeight="bold">{'Relation'}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <div className='w-100'>
                            <NewRelation
                            clear={clear}
                            country={selectedCountry}
                            source={HCPRequest.entity.Source[0].value}
                            newHCP={true}
                            newData={filterdata}
                            error={relationError}
                            AddNewRelation={(newValue, flag) => {
                                updateValue(newValue, flag, 'Relation')
                            }}
                            />
                        </div>
                        {optionalRelation === 'Optional' && (
                            <Link
                            to='#'
                            className='pointer'
                            onClick={() => {
                                setShowRelation(false)
                                setCancel('Relation')
                            }}
                            >
                            <Cancel className='text-danger ' />
                            </Link>
                        )}
                        </AccordionDetails>
                    </Accordion>
                    )
                }

                {
                    optionalRelation === 'Optional' && !showRelation && (
                        <AccordionActions className='d-flex justify-content-center mt-4 mb-3'>
                        <Link
                            to='#'
                            className='pointer'
                            onClick={() => {
                            setShowRelation(true)
                            addOptional('Relation')
                            }}
                        >
                            <Add />
                            Add Relation
                        </Link>
                        </AccordionActions>
                    )
                }

                {
                    !address &&
                        optionalRelation === 'Required' &&
                        CONSTANT.DISABLE_ADD_ADDRESS_HCP && (
                        <AccordionActions className='d-flex justify-content-center mt-4 mb-3'>
                            <Link
                            to='#'
                            className='pointer'
                            onClick={() => {
                                setAddress(true)
                                addOptional('Address')
                            }}
                            >
                            <Add />
                            Add Address
                            </Link>
                        </AccordionActions>
                        )
                }


                <DialogActions className="d-flex justify-content-center mt-4 mb-3" id="newhcp-button" sx={{display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Button className="btn btn-secondry border clearall" onClick={() => { clearAll() }} color="error" variant="outlined">
                        CLEAR ALL
                    </Button>
                    <Button className="btn btn-secondry border request" onClick={() => { submitRequest() }} color="error" variant="contained">
                        REQUEST
                    </Button>
                </DialogActions>
                </>
                
                {
                    modal.flag && (
                    <Popup
                        updateDetails={{...HCPRequest, entity: {...HCPRequest.entity, ...(LillySources.LILLY_MANAGED_SOURCES.includes(newSource) ? {IsNew: true} : {})}}}
                        closePopup={() => {
                        setModal(false)
                        }}
                        open={modal.flag}
                        success={modal.success}
                        message={modal.message}
                        title={modal.title}
                        typeHCP={true}
                        addNewHCP={true}
                        flag={modal.flag}
                        close={() => {
                        setModal(false)
                        goBack()
                        }}
                        source = {newSource}
                    />
                    )
                }

                </div >

            }          

            {
                errorMsg !== undefined &&
                <ErrorPage message={errorMsg} />
            } 
        </div>

    )}

export default AddNewHCP;
